module.exports = __webpack_public_path__ + "static/img/guide.adbdf5fb.png";